import { postRequest } from '../../utils/api'
import { getRequest } from '../../utils/api'
import { postRequest2 } from '../../utils/api'

//获取省列表数据
export function postProvinces() {
    return postRequest(
        `/dim/queryAllProvince`
    )
}
//获取市列表数据
export function postCitys(params) {
    return postRequest(
        `/dim/queryAllCity?province=${params}`,
    )
}
//供应商列表(多条件查询)
export function supplierList(currentPage, limit, name) {
    return getRequest(
        `/jxc/supplierList?page=${currentPage}&limit=${limit}&name=${name}`,
    )
}
//新增供应商信息
export function addSupplier(params) {
    return postRequest2(
        `/jxc/addSupplier`,
        params
    )
}
//修改供应商信息
export function updateSupplier(params) {
    return postRequest2(
        `/jxc/updateSupplier`,
        params
    )
}
//删除供应商
export function deleteSupplier(params) {
    return postRequest2(
        `/jxc/deleteSupplier`,
        params
    )
}
//（单个）供应商信息查询
export function querySupplier(params) {
    return getRequest(
        `/jxc/querySupplier?id=${params}`,
    )
}

